import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Modal

} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Navber from "./Navber.jsx";
import api from "../Api.js"
import dayjs from "dayjs";
import Fullspin from "./Helping Component/Fullscreeenspinner.jsx"

export default function TripForm() {
  const [days, setDays] = useState([{ day: 1, value: "" }]);
  const [Itinerary, setItinerary] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    destination: "",
    pickup: "",
    drop: "",
    adult: null,
    child: null,
    infant: null,
    days: null,
    nights: null,
    startDate: null,
    name: "",
    email: "",
    phone: "",
    special: "",
    travel: "",
    food: ""
  });

  const [planType, setPlanType] = useState("budget_itinerary");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const handlePlanChange = (e, newType) => {
    if (newType !== null) {
      setPlanType(newType);
    }
  };
  const handleAddDay = () => {

    setDays((prev) => [
      ...prev,
      { day: prev.length + 1, value: "" }, // new day number
    ]);
  };

  const handleChanges = (index, newValue) => {
    const updated = [...days];
    updated[index].value = newValue;
    // setItinerary(updated[index].value)




    setDays(updated);
    const iti = days.map(item => item.value)
    setItinerary(iti)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const submittedData = {
      type: planType,
      destination: formData.destination,
      pickup: formData.pickup,
      drop: formData.drop,
      adult: formData.adult,
      child: formData.child,
      infant: formData.infant,
      no_of_days: formData.days,
      no_of_nights: formData.nights,
      start_date: dayjs(formData.startDate).format("YYYY-MM-DD"),
      travel: formData.travel,
      food: formData.food,
      special_request: formData.special,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      itineraries: Itinerary
    }
    console.log("submittedData: ", submittedData);

    try {
      //       if(submittedData.type==="" && submittedData.destination ==="" && submittedData.pickup === "" && submittedData.drop === "" && submittedData.adult === 0 && submittedData.name ==="" && submittedData.email ==="" && submittedData.phone ===""){
      //   alert("please fill all required field...")
      //     return
      // }
      setLoading(true)
      const res = await api.post("/budget-requests", submittedData);
      console.log(res);

      if (res?.data?.status === true) {
        setLoading(false);
        setOpen(true);


      }

    } catch (err) {
      console.log(err)
    }



    // console.log(days);
    // console.log(Itinerary);
  };

  return (
    <>
      {loading && <Fullspin />}
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>
      <Box
        sx={{
          position: "relative",
          height: { xs: 200, md: 300 },
          backgroundImage:
            "url('https://images.unsplash.com/photo-1500530855697-b586d89ba3ee')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: "0 0 30px 30px",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.6))",
            borderRadius: "0 0 30px 30px",
          }}
        />
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            textAlign: "center",
            px: 2,
          }}
        >
          <Typography variant="h4" fontWeight="bold">
            Plan Your Dream Trip ✈️
          </Typography>
          <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
            Personalized itinerary crafted just for you
          </Typography>
        </Box>
      </Box>

      {/* successfull overlay */}
      <div>
        {/* Simulate a submit button */}


        <Modal
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="success-title"
          aria-describedby="success-desc"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 350,
              bgcolor: "background.paper",
              borderRadius: 3,
              boxShadow: 24,
              p: 4,
              textAlign: "center",
            }}
          >
            <Typography id="success-title" variant="h6" component="h2" sx={{ mb: 1 }}>
              🎉 Submitted Successfully!
            </Typography>
            <Typography id="success-desc" sx={{ mb: 2, color: "text.secondary" }}>
              Your itinerary request has been sent.
            </Typography>
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                setOpen(false);
                window.location.reload();


              }}
              sx={{ borderRadius: 2 }}
            >
              Close
            </Button>
          </Box>
        </Modal>
      </div>


      <Box
        sx={{
          maxWidth: 900,
          mx: "auto",
          mt: -6,
          p: { xs: 2, md: 4 },
          borderRadius: 4,
          bgcolor: "#ffffff",
          boxShadow: "0 20px 40px rgba(0,0,0,0.12)",
        }}
      >

        {/* Toggle Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 4,
          }}
        >
          <ToggleButtonGroup
            value={planType}
            exclusive
            onChange={handlePlanChange}
            sx={{
              bgcolor: "#f5f5f5",
              borderRadius: "30px",
              p: 0.5,
            }}
          >
<ToggleButton
  value="budget_itinerary"
  sx={{
    borderRadius: "30px",
    px: 3,
    fontWeight: "bold",
    textTransform: "none",
    bgcolor: "#e6e6e6",
    border: "none",

    color: "#333",
   

    "&:hover": {
      bgcolor: "#e6e6e6",
    },

    "&.Mui-selected": {
      bgcolor: "#a8712a",
      color: "#fff",

      "&:hover": {
        bgcolor: "#a8712a", // 👈 keep SAME on hover
      },
    },
  }}
>
  Budget + Itinerary
</ToggleButton>

<ToggleButton
  value="budget_basic"
  sx={{
    borderRadius: "30px",
    px: 3,
    fontWeight: "bold",
    textTransform: "none",
    bgcolor: "#e6e6e6",
    border: "none",

    color: "#333",
    

    "&:hover": {
      bgcolor: "#e6e6e6",
    },

    "&.Mui-selected": {
      bgcolor: "#a8712a",
      color: "#fff",

      "&:hover": {
        bgcolor: "#a8712a", // 👈 no flicker
      },
    },
  }}
>
  Only Budget
</ToggleButton>

          </ToggleButtonGroup>
        </Box>


        {/* Form */}
        {
          planType === "budget_itinerary" ?
            <form onSubmit={handleSubmit}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container spacing={2} justifyContent="center" display="flex" flexDirection="column">

                  {/* Destination / Pickup / Drop */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Destination"
                      name="destination"
                      value={formData.destination}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Pickup"
                      name="pickup"
                      value={formData.pickup}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Drop"
                      name="drop"
                      value={formData.drop}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  {/* Adults / Child / Infant */}
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="No. of Adults"
                      name="adult"
                      type="number"
                      value={formData.adult}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          adult: value < 1 ? 1 : value,
                        }));
                      }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="No. of Children"
                      name="child"
                      type="number"
                      value={formData.child}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          child: value < 0 ? 0 : value,
                        }));
                      }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="No. of Infants"
                      name="infant"
                      type="number"
                      value={formData.infant}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          infant: value < 0 ? 0 : value,
                        }));
                      }}
                      required
                    />
                  </Grid>

                  {/* Days / Nights */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Total no. of days"
                      name="days"
                      type="number"
                      value={formData.days}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          days: value < 1 ? 1 : value,
                        }));
                      }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Total no. of nights"
                      name="nights"
                      type="number"
                      value={formData.nights}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          nights: value < 1 ? 1 : value,
                        }));
                      }}
                      required
                    />
                  </Grid>

                  {/* Date Pickers */}
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="Check-in"
                      value={formData.startDate}
                      onChange={(newValue) =>
                        setFormData((prev) => ({ ...prev, startDate: newValue }))
                      }
                      minDate={new Date()}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth required />
                      )}
                    />
                  </Grid>


                  {/* Name & Email */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  {/* Phone */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Phone No."
                      name="phone"
                      type="tel"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  {/* Special Request */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      minRows={4}
                      label="Any special request"
                      name="special"
                      value={formData.special}
                      onChange={handleChange}

                    />
                  </Grid>

                  <Grid item xs={12} textAlign="center">
                    <Button
                      type="submit"
                      size="large"
                      sx={{
                        mt: 3,
                        px: 6,
                        py: 1.5,
                        borderRadius: "30px",
                        color: "#fff",
                        bgcolor: "#a8712a",
                        fontWeight: "bold",
                        boxShadow: "0 8px 20px rgba(168,113,42,0.4)",
                        "&:hover": {
                          bgcolor: "#8f5e1f",
                        },
                      }}
                    >
                      Send Request 🚀
                    </Button>

                  </Grid>
                </Grid>
              </LocalizationProvider>
            </form>
            :
            <form onSubmit={handleSubmit}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container spacing={2} justifyContent="center" display="flex" flexDirection="column">

                  {/* Destination / Pickup / Drop */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Destination"
                      name="destination"
                      value={formData.destination}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Pickup"
                      name="pickup"
                      value={formData.pickup}
                      onChange={handleChange} required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Drop"
                      name="drop"
                      value={formData.drop}
                      onChange={handleChange} required
                    />
                  </Grid>

                  {/* Adults / Child / Infant */}
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="No. of Adults"
                      name="adult"
                      type="number"
                      value={formData.adult}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          adult: value < 1 ? 1 : value,
                        }));
                      }} required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="No. of Children"
                      name="child"
                      type="number"
                      value={formData.child}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          child: value < 0 ? 0 : value,
                        }));
                      }} required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="No. of Infants"
                      name="infant"
                      type="number"
                      value={formData.infant}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          infant: value < 0 ? 0 : value,
                        }));
                      }} required
                    />
                  </Grid>

                  {/* Days / Nights */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Total no. of days"
                      name="days"
                      type="number"
                      value={formData.days}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          days: value < 1 ? 1 : value,
                        }));
                      }} required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Total no. of nights"
                      name="nights"
                      type="number"
                      value={formData.nights}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          nights: value < 1 ? 1 : value,
                        }));
                      }} required
                    />
                  </Grid>

                  {/* Date Pickers */}
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="Check-in"
                      value={formData.startDate}
                      onChange={(newValue) =>
                        setFormData((prev) => ({ ...prev, startDate: newValue }))
                      }
                      minDate={new Date()}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth required />
                      )}
                    />
                  </Grid>


                  {/* Dynamic Day Inputs */}
                  <Grid item xs={6} display="flex" flexDirection="column" justifyContent="center">
                    {days.map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <TextField
                          label={`Day ${item.day}`}
                          variant="outlined"
                          fullWidth
                          value={item.value}
                          onChange={(e) => handleChanges(index, e.target.value)}
                          sx={{ width: "100%" }}
                        />
                      </Box>
                    ))}
                    <Button
                      variant="contained"
                      color="warning"
                      onClick={handleAddDay}
                      startIcon={<AddIcon />}
                      sx={{ mt: 1, width: "35%" }}
                    >
                      Add Day
                    </Button>
                  </Grid>
                  {/* Name & Email */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Travel and Preference"
                      name="travel"
                      value={formData.travel}
                      onChange={handleChange} required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Food"
                      name="food"
                      value={formData.food}
                      onChange={handleChange} required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange} required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange} required
                    />
                  </Grid>

                  {/* Phone */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Phone No."
                      name="phone"
                      type="tel"
                      value={formData.phone}
                      onChange={handleChange} required
                    />
                  </Grid>

                  {/* Special Request */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      minRows={4}
                      label="Any special request"
                      name="special"
                      value={formData.special}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} textAlign="center">
                    <Button
                      type="submit"
                      size="large"
                      sx={{
                        mt: 3,
                        px: 6,
                        py: 1.5,
                        borderRadius: "30px",
                        bgcolor: "#a8712a",
                        color: "#fff",
                        fontWeight: "bold",
                        boxShadow: "0 8px 20px rgba(168,113,42,0.4)",
                        "&:hover": {
                          bgcolor: "#8f5e1f",
                        },
                      }}
                    >
                      Send Request 🚀
                    </Button>

                  </Grid>
                </Grid>
              </LocalizationProvider>
            </form>
        }

      </Box>
    </>

  );
}
